import styled from 'styled-components';

export const GridArea = styled.div`
  .MuiDataGrid-cell {
    text-transform: capitalize;
  }
`;

export const BirthDayTitle = styled.div`
align-items: center;
  display: flex;
  justify-content: space-around;
  width: 100%;
  color: ${({ theme }) => theme.palette.primary.main};
  padding: 10px 0;
  font-weight: 400 !important;
  svg {
    font-size: 120px;
  }
  h5 {
    font-size: 42px;
    line-height: 1;
    b {
      font-weight: 400 !important;
      font-size: 140px;
    }
  }
  h4 {
    font-size: 42px;
    text-align: center;
    line-height: 0.9;
    margin-top: 20px;
    b {
      font-weight: 400 !important;
      font-size: 100px;
    }
  }
  @media only screen and (max-width: 992px) {
    svg {
      font-size: 90px;
    }
    h5,
    h4 {
      font-size: 45px;
      text-align: center;
      b {
        font-size: 80px;
      }
    }
  }
  @media only screen and (max-width: 768px) {
    display: block;
    text-align: center;
    svg {
      font-size: 70px;
      margin-bottom: 20px;
    }
    h5,
    h4 {
      margin-bottom: 20px;
    }
  }
  @media only screen and (max-width: 480px) {
    font-size: 12px;
    h4 b {
      font-size: 45px;
      text-align: center;
      line-height: 60px;
    }
  }
`;

export const Birthday = styled.div`
  display: flex;
`;